/**
 * 动物配对理由数据
 * 格式: { "当前动物": { "配对动物": "配对理由" } }
 */
export const compatibilityReasons = {
  "狗": {
    "水豚": "你们都热爱社交，情绪稳定，能互相给予安全感和温暖。",
    "鹦鹉": "你们都是社交达人，活泼开朗，能一起创造欢乐的氛围。",
    "海豚": "你们都重视团队合作，充满活力，能互相激励成长。",
    "草泥马": "你们都热爱社交且温和友善，在团队中都能发挥积极作用，互相给予温暖支持。",
    "狼": "你们都有团队精神，虽然风格不同但能互相理解。",
    "鲸": "你们都重视社群，能互相给予情感支持。",
    "猪": "你们都擅长社交且乐观开朗，能在轻松愉快的氛围中建立深厚友谊。",
    "猫": "你们性格差异较大，需要更多理解和包容。",
    "鲨鱼": "你们的生活方式差异很大，需要磨合才能和谐相处。",
    "鹰": "你们的社交需求完全不同，需要互相尊重彼此的空间。",
    "蚊子": "你依赖团队和陪伴，而蚊子习惯独来独往，需要学会尊重彼此的生活方式。"
  },
  "猫": {
    "狐": "你们都独立聪明，能理解彼此的独处需求。",
    "章鱼": "你们都智慧独立，能欣赏彼此的创造力和策略。",
    "鹰": "你们都享受独处，有相似的独立精神。",
    "猪": "你们都懂得享受生活的美好，能在慢节奏中互相理解和陪伴。",
    "蝴蝶": "你们都优雅灵动且追求美感，能在审美和自由中找到共鸣。",
    "鹿": "你们都温和优雅，能互相欣赏彼此的美学追求。",
    "天鹅": "你们都追求美和优雅，有相似的理想主义。",
    "蚊子": "你们都独立敏捷且善于观察，能欣赏彼此的灵活性和独立性。",
    "狗": "你们的社交需求差异很大，需要互相理解。",
    "水豚": "你们的性格差异较大，需要更多沟通。",
    "猫鼬": "你们的生活方式不同，需要磨合。"
  },
  "狼": {
    "狗": "你们都重视团队，能互相支持，形成强大的合作。",
    "海豚": "你们都擅长团队合作，能互相激励，共同成长。",
    "猫鼬": "你们都有强烈的保护欲，能互相理解和支持。",
    "乌鸦": "你们都聪明且有战略思维，能互相学习。",
    "鲸": "你们都有领导力和智慧，能互相尊重。",
    "猫": "你们的性格差异较大，需要更多理解。",
    "鲨鱼": "虽然都强势，但需要找到平衡点。",
    "猪": "你目标导向强而猪享受当下，价值观差异需要耐心磨合和互相包容。"
  },
  "狐": {
    "猫": "你们都独立聪明，能理解彼此的独处需求。",
    "章鱼": "你们都智慧且策略性强，能互相欣赏。",
    "乌鸦": "你们都聪明且善于观察，能互相学习。",
    "鹰": "你们都独立且有远见，能互相理解。",
    "浣熊": "你们都灵活聪明，能一起探索和冒险。",
    "蟑螂": "你们都善于适应环境和规避风险，能互相欣赏对方的生存智慧。",
    "蚊子": "你们都机敏灵活善于捕捉机会，在策略思维上能产生强烈共鸣。",
    "狗": "你喜欢独处和策略，而狗依赖社群，需要互相适应。",
    "水豚": "你追求智慧和独立，而水豚佛系随和，理念差异较大。",
    "草泥马": "你独立聪明而草泥马温和依赖团队，需要找到平衡点。"
  },
  "狮": {
    "狼": "你们都强势且有领导力，能互相尊重和合作。",
    "鹰": "你们都自信且有统御力，能互相欣赏。",
    "鲨鱼": "你们都目标导向，能互相激励。",
    "海豚": "你们都充满魅力，能互相欣赏。",
    "乌鸦": "你们都聪明且有影响力。",
    "猫": "你们的性格差异较大。",
    "狐": "你们的风格不同，需要磨合。",
    "蟑螂": "你追求荣耀和光环，而蟑螂务实低调求生存，价值观需要大量磨合。"
  },
  "熊": {
    "兔": "你们都重视安全感，能互相给予温暖和保护。",
    "仓鼠": "你们都享受安逸，能一起创造舒适的生活。",
    "鹿": "你们都温和，能互相理解和支持。",
    "蟑螂": "你们都极度重视安全和稳定，能理解彼此对安全感的深刻需求。",
    "狗": "你们都重视家庭和安全感。",
    "猫鼬": "你们都有保护欲，能互相支持。",
    "鲨鱼": "你们的生活方式差异很大。",
    "狮": "你们的性格差异较大。",
    "蝴蝶": "你沉稳慢节奏追求稳定，而蝴蝶灵动追求自由，生活理念需要磨合。"
  },
  "兔": {
    "熊": "你们都重视安全感，能互相给予温暖。",
    "鹿": "你们都温和敏感，能互相理解。",
    "水豚": "你们都温和随和，能一起享受平静。",
    "蟑螂": "你们都警惕谨慎且高度重视安全，能深刻理解彼此的生存本能。",
    "狗": "你们都重视安全感，能互相支持。",
    "仓鼠": "你们都享受安逸，能一起创造舒适。",
    "鲨鱼": "你们的性格差异很大。",
    "鹰": "你们的社交需求完全不同。",
    "狼": "你们的性格差异较大。"
  },
  "仓鼠": {
    "熊": "你们都享受安逸，能一起创造舒适的生活。",
    "兔": "你们都重视安全感，能互相理解。",
    "鹿": "你们都温和，能一起享受平静。",
    "蟑螂": "你们都极度重视安全感和囤积资源，能深刻理解彼此的生存智慧。",
    "猪": "你们都追求舒适安逸且享受慢节奏，能一起创造温馨惬意的环境。",
    "猫": "你们都享受独处，能互相理解。",
    "水豚": "你们都随和，能一起享受生活。",
    "鲨鱼": "你们的生活方式差异很大。",
    "鹰": "你们的性格差异较大。",
    "蝴蝶": "你喜欢囤积和稳定，而蝴蝶追求自由和变化，理念截然不同。"
  },
  "天鹅": {
    "鹿": "你们都追求美和优雅，能互相欣赏。",
    "猫": "你们都优雅且有美学追求，能互相理解。",
    "鲸": "你们都优雅且有深度，能互相欣赏。",
    "蝴蝶": "你们都追求极致美学和精神自由，能深刻理解彼此对美的执着追求。",
    "天鹅": "你们都追求完美，能互相理解。",
    "鹦鹉": "你们都优雅，能互相欣赏。",
    "水豚": "你们的性格差异较大。",
    "狗": "你们的追求不同。",
    "蟑螂": "你追求极致优雅和完美，而蟑螂务实求生存，审美观完全不同。"
  },
  "鹿": {
    "兔": "你们都温和敏感，能互相理解和支持。",
    "天鹅": "你们都追求美和优雅，能互相欣赏。",
    "熊": "你们都温和，能互相给予温暖。",
    "草泥马": "你们都温和优雅且性格随和，能在平静和谐中互相理解和支持。",
    "蝴蝶": "你们都优雅敏捷且追求美感，能深刻欣赏彼此身上的灵动与纯净。",
    "猫": "你们都优雅，能互相理解。",
    "鲸": "你们都温和且有深度。",
    "猪": "你们都温和随性且享受平静，能一起创造宁静美好的生活。",
    "鲨鱼": "你们的性格差异很大。",
    "狼": "你们的性格差异较大。"
  },
  "鹰": {
    "猫": "你们都享受独处，能互相理解彼此的独立。",
    "狐": "你们都独立且有远见，能互相欣赏。",
    "章鱼": "你们都智慧独立，能互相理解。",
    "蚊子": "你们都独立行动且目光敏锐，能欣赏彼此的独立意志和灵活策略。",
    "狮": "你们都自信且有统御力。",
    "鲨鱼": "你们都目标导向，能互相理解。",
    "狗": "你们的社交需求完全不同。",
    "水豚": "你们的性格差异很大。",
    "鹦鹉": "你们的追求不同。",
    "草泥马": "你享受孤独和高处视野，而草泥马需要群体陪伴，理念冲突明显。",
    "猪": "你追求远大目标和格局，而猪享受当下舒适，价值观需要磨合。"
  },
  "乌鸦": {
    "狐": "你们都聪明且善于观察，能互相学习。",
    "章鱼": "你们都智慧且策略性强，能互相欣赏。",
    "海豚": "你们都聪明且社交能力强，能互相激励。",
    "蚊子": "你们都聪明善于观察且反应敏捷，能在智慧和策略上互相学习切磋。",
    "狼": "你们都聪明且有战略思维。",
    "浣熊": "你们都灵活聪明，能一起探索。",
    "仓鼠": "你们的性格差异较大。",
    "兔": "你们的追求不同。"
  },
  "水豚": {
    "狗": "你们都热爱社交，能互相给予温暖。",
    "鹦鹉": "你们都活泼开朗，能一起创造欢乐。",
    "猫鼬": "你们都随和，能互相理解和支持。",
    "草泥马": "你们都随和佛系且情绪稳定，能在平和包容中一起享受平静的生活。",
    "猪": "你们都随和享乐且乐观开朗，能毫无压力地一起享受生活的美好时光。",
    "海豚": "你们都社交能力强，能互相激励。",
    "鲸": "你们都温和，能互相理解。",
    "猫": "你们的性格差异较大。",
    "鹰": "你们的社交需求完全不同。",
    "鲨鱼": "你们的生活方式差异很大。",
    "蚊子": "你佛系随和喜欢社交，而蚊子独立机会主义，生活方式完全不同。"
  },
  "鲸": {
    "海豚": "你们都聪明且社交能力强，能互相理解。",
    "天鹅": "你们都优雅且有深度，能互相欣赏。",
    "鹿": "你们都温和且有深度，能互相理解。",
    "草泥马": "你们都温和包容且性格平和，能在深沉的理解中互相支持。",
    "猪": "你们都温和包容且懂得享受，能在智慧和乐观中找到共鸣。",
    "蝴蝶": "你们都有美学追求和精神深度，能欣赏彼此对美和自由的向往。",
    "狼": "你们都聪明且有智慧。",
    "猫": "你们都独立且有深度。",
    "鲨鱼": "你们的性格差异较大。",
    "兔": "你们的追求不同。"
  },
  "鹦鹉": {
    "狗": "你们都热爱社交，能一起创造欢乐。",
    "水豚": "你们都活泼开朗，能互相激励。",
    "海豚": "你们都社交能力强，能一起探索。",
    "蝴蝶": "你们都活泼灵动且充满表现力，能在欢乐和美感中一起创造美好回忆。",
    "猫鼬": "你们都活泼，能互相理解。",
    "乌鸦": "你们都聪明，能互相学习。",
    "猫": "你们的性格差异较大。",
    "鹰": "你们的追求不同。"
  },
  "章鱼": {
    "狐": "你们都智慧且策略性强，能互相欣赏。",
    "猫": "你们都智慧独立，能互相理解。",
    "鹰": "你们都智慧独立，能互相欣赏。",
    "蚊子": "你们都智慧独立且适应力极强，能深刻理解彼此灵活多变的生存策略。",
    "乌鸦": "你们都聪明，能互相学习。",
    "浣熊": "你们都灵活聪明，能一起探索。",
    "狗": "你们的性格差异较大。",
    "水豚": "你们的追求不同。"
  },
  "鲨鱼": {
    "鹰": "你们都目标导向，能互相理解。",
    "狮": "你们都强势，能互相尊重。",
    "狼": "你们都强势，需要找到平衡。",
    "章鱼": "你们都独立，能互相理解。",
    "浣熊": "你们都灵活，能互相欣赏。",
    "狗": "你们的生活方式差异很大。",
    "水豚": "你们的性格差异很大。",
    "兔": "你们的追求完全不同。",
    "猫鼬": "你们的性格差异较大。",
    "蟑螂": "你高效追逐目标永不停歇，而蟑螂谨慎求生存，生存哲学截然不同。",
    "草泥马": "你目标导向行动迅速，而草泥马温和慢节奏，节奏差异需要大量磨合。",
    "猪": "你专注目标不断前进，而猪享受当下慢生活，价值观冲突明显。"
  },
  "海豚": {
    "狗": "你们都重视团队合作，能互相激励。",
    "鹦鹉": "你们都社交能力强，能一起探索。",
    "狼": "你们都擅长团队合作，能互相支持。",
    "草泥马": "你们都社交能力强且性格友善，能在团队协作中一起创造快乐氛围。",
    "蝴蝶": "你们都充满活力且灵动自由，能在玩乐和探索中一起发现世界的美好。",
    "水豚": "你们都社交能力强，能互相理解。",
    "鲸": "你们都聪明，能互相理解。",
    "猫鼬": "你们都活泼，能互相支持。",
    "猫": "你们的性格差异较大。",
    "鹰": "你们的追求不同。"
  },
  "浣熊": {
    "狐": "你们都灵活聪明，能一起探索和冒险。",
    "章鱼": "你们都灵活聪明，能互相欣赏。",
    "乌鸦": "你们都灵活聪明，能互相学习。",
    "蟑螂": "你们都灵活务实且适应力强，能在生存智慧和应变能力上互相欣赏。",
    "蚊子": "你们都灵活机敏善于找机会，能在探险和冒险中成为完美搭档。",
    "浣熊": "你们都灵活，能一起探索。",
    "鹦鹉": "你们都好奇，能互相激励。",
    "熊": "你们的性格差异较大。",
    "狮": "你们的追求不同。"
  },
  "猫鼬": {
    "狗": "你们都重视团队，能互相支持。",
    "水豚": "你们都随和，能互相理解。",
    "狼": "你们都有保护欲，能互相支持。",
    "鹦鹉": "你们都活泼，能互相理解。",
    "海豚": "你们都重视团队，能互相支持。",
    "蟑螂": "你们都极度重视安全和警惕性，能深刻理解彼此的生存本能和守护意识。",
    "草泥马": "你们都有团队精神且重视归属感，能在集体中互相支持守护。",
    "猫": "你们的性格差异较大。",
    "鹰": "你们的追求不同。",
    "鲨鱼": "你们的性格差异较大。",
    "蚊子": "你依赖团队协作和归属感，而蚊子独立机会主义，生活方式冲突明显。"
  },
  "蟑螂": {
    "仓鼠": "你们都极度重视安全感和资源囤积，能深刻理解彼此对生存的执着智慧。",
    "熊": "你们都追求安全稳定和强大的庇护所，能在安全感中互相给予保护。",
    "兔": "你们都警惕谨慎且反应敏捷，能深刻理解彼此对安全的本能需求。",
    "狐": "你们都善于适应环境和规避风险，能欣赏彼此灵活的生存策略和智慧。",
    "浣熊": "你们都灵活务实且动手能力强，能在应对挑战时成为可靠的战友。",
    "猫鼬": "你们都极度重视安全和警惕，能理解彼此时刻保持警觉的生存本能。",
    "狮": "你追求低调务实的生存，而狮追求荣耀和光环，价值观需要大量磨合。",
    "鲨鱼": "你谨慎求生存，而鲨鱼高效追逐目标，生存哲学和行动方式完全不同。",
    "天鹅": "你务实求生不在意外表，而天鹅追求极致优雅，审美观截然相反。"
  },
  "草泥马": {
    "狗": "你们都热爱社交且温和友善，能在团队中互相给予温暖和情感支持。",
    "水豚": "你们都随和佛系且情绪稳定，能毫无压力地一起享受平静悠闲的生活。",
    "鹿": "你们都温和优雅且追求和谐，能在宁静中互相理解和深度支持。",
    "猫鼬": "你们都有团队精神和归属感，能在集体中互相守护和支持。",
    "海豚": "你们都社交能力强且充满活力，能在欢乐的氛围中一起创造快乐。",
    "鲸": "你们都温和包容且有深度，能在智慧和平和中互相理解。",
    "鲨鱼": "你慢节奏温和随性，而鲨鱼高效目标导向，节奏和理念差异需要磨合。",
    "鹰": "你需要群体陪伴和归属感，而鹰享受孤独和高处视野，社交需求冲突。",
    "狐": "你温和依赖团队，而狐独立聪明善于策略，性格和生活方式差异较大。"
  },
  "猪": {
    "水豚": "你们都随和享乐且乐观开朗，能在轻松愉快中一起享受生活的美好。",
    "猫": "你们都懂得享受且追求舒适，能在慢节奏的生活中互相理解和陪伴。",
    "仓鼠": "你们都追求舒适安逸和小确幸，能一起创造温馨惬意的生活环境。",
    "狗": "你们都社交能力强且热情友善，能在欢乐中互相给予温暖和陪伴。",
    "鹿": "你们都温和随性且享受平静，能在宁静中一起享受生活的美好。",
    "鲸": "你们都温和包容且有智慧，能在深度理解中互相欣赏和支持。",
    "鲨鱼": "你享受当下慢生活，而鲨鱼专注目标不停歇，生活方式和节奏差异巨大。",
    "狼": "你享受舒适不喜竞争，而狼目标导向有强烈责任感，价值观需要磨合。",
    "鹰": "你追求当下的快乐和舒适，而鹰追求远大格局和目标，理念冲突明显。"
  },
  "蚊子": {
    "狐": "你们都机敏灵活善于捕捉机会，能在策略思维和智慧上互相欣赏切磋。",
    "章鱼": "你们都智慧独立且适应力极强，能深刻理解彼此灵活多变的生存之道。",
    "浣熊": "你们都灵活机敏且善于找机会，能在探索冒险中成为完美的行动搭档。",
    "乌鸦": "你们都聪明善于观察且反应敏捷，能在智慧和策略上互相学习进步。",
    "猫": "你们都独立敏捷且善于观察，能欣赏彼此的灵活性和独立自主的精神。",
    "鹰": "你们都独立行动且目光敏锐，能在高度独立和远见上互相欣赏理解。",
    "狗": "你独立机会主义喜欢独处，而狗依赖团队需要陪伴，社交需求冲突。",
    "水豚": "你独立行动追求机会，而水豚佛系随和喜欢社交，性格和生活方式差异大。",
    "猫鼬": "你独来独往不需要归属感，而猫鼬依赖团队协作，生活方式完全相反。"
  },
  "蝴蝶": {
    "猫": "你们都优雅灵动且追求美感，能在审美和自由中深刻互相欣赏理解。",
    "天鹅": "你们都追求极致美学和精神自由，能在对美的执着中产生强烈共鸣。",
    "鹿": "你们都优雅敏捷且追求美感，能深刻欣赏彼此身上的灵动与纯净之美。",
    "鹦鹉": "你们都活泼灵动且充满表现力，能在欢乐和美感中一起创造美好时光。",
    "海豚": "你们都充满活力且灵动自由，能在玩乐和探索中一起发现世界的精彩。",
    "鲸": "你们都有美学追求和精神深度，能欣赏彼此对美和自由的向往与追求。",
    "熊": "你追求自由和变化灵动多变，而熊沉稳慢节奏追求稳定，生活节奏冲突。",
    "仓鼠": "你追求自由和飞翔不喜束缚，而仓鼠喜欢囤积和小窝，理念完全相反。",
    "蟑螂": "你追求极致美学和优雅自由，而蟑螂务实求生存，价值观和审美截然不同。"
  }
}

/**
 * 获取两个动物的配对理由
 * @param {string} currentAnimal - 当前动物名称
 * @param {string} pairedAnimal - 配对动物名称
 * @returns {string} 配对理由，如果不存在则返回默认理由
 */
export function getCompatibilityReason(currentAnimal, pairedAnimal) {
  // 先尝试直接查找
  if (compatibilityReasons[currentAnimal] && compatibilityReasons[currentAnimal][pairedAnimal]) {
    return compatibilityReasons[currentAnimal][pairedAnimal]
  }
  
  // 如果找不到，尝试反向查找
  if (compatibilityReasons[pairedAnimal] && compatibilityReasons[pairedAnimal][currentAnimal]) {
    return compatibilityReasons[pairedAnimal][currentAnimal]
  }
  
  // 默认理由
  return "你们有着独特的相处方式，需要互相理解和包容。"
}

